const config = {
  testStg: "enot-stg22.rtty.in",
  sentry: "https://7dbf5c6cf0fc47f0aa17cb1339227d5b@sentry.devdelive.com/2",
  env: process.env.REACT_APP_NODE_ENV || "development",
  websocket: process.env.REACT_APP_WEBSOCKET === "on" || false,
  websocketUrl: process.env.REACT_APP_WEBSOCKET_URL || "http://localhost:4000",
  showTranslateErrors:
    process.env.REACT_APP_SHOW_TRANSLATE_ERRORS === "yes" || false,
  appTitle: "Notix",
  role: "publisher",
  partnerAlias: "notix",
  captchaKey: process.env.REACT_APP_CAPTCHA_KEY || "",
  callbackInstruction:
    "https://help.propellerads.com/propush-me/how-to-use-custom-elements-of-propushme-code",
  trafficBackInstruction:
    "https://help.propellerads.com/propush-me/how-to-implement-trafficback-link-in-propushme-code",
  gtmCode: process.env.REACT_APP_GOOGLE_TAG_MANAGER_CODE || "",
  supportEmail: "support@notix.co",
  footerLinks: {
    help_center: {
      title: "help_link_title",
      href: "https://help.notix.co/",
    },
    docs: {
      title: "docs_link_title",
      href: "https://docs.notix.co/",
    },
    tg_en: {
      title: "Telegram",
      href: "https://t.me/notixio",
    },
    tg_ru: {
      title: "Telegram",
      href: "https://t.me/notixio_ru",
    },
  },
};

export default config;
